import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UsuarioRoutingModule } from './usuario-routing.module';
import { IndexComponent } from './pages/index/index.component';
import { NovoComponent } from './pages/novo/novo.component';
import { DetalhesComponent } from './pages/detalhes/detalhes.component';
import {ComponentesModule} from "../../../core/componentes/componentes.module";
import {NgSelectModule} from "@ng-select/ng-select";
import {ReactiveFormsModule} from "@angular/forms";
import {EmpresaModule} from "../../cadastro/empresa/empresa.module";
import { ConfirmarEmailComponent } from './pages/confirmar-email/confirmar-email.component';


@NgModule({
  declarations: [
    IndexComponent,
    NovoComponent,
    DetalhesComponent,
    ConfirmarEmailComponent
  ],
    imports: [
        CommonModule,
        UsuarioRoutingModule,
        ComponentesModule,
        NgSelectModule,
        ReactiveFormsModule,
        EmpresaModule
    ]
})
export class UsuarioModule { }
